import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';

const sections = [
  {
    title: '1. Donnees collectées',
    items: [
      'Nous collectons les informations necessaires a la creation et a la gestion des comptes revendeurs, comme le nom, le prenom, l email, le numero de telephone et les informations d entreprise.',
      'Nous pouvons egalement traiter les donnees techniques necessaires a la connexion, a la securite des comptes et a l utilisation des services de la plateforme.'
    ]
  },
  {
    title: '2. Finalites du traitement',
    items: [
      'Les donnees sont utilisees pour creer, verifier et administrer les comptes utilisateurs.',
      'Elles servent aussi a traiter les commandes, gerer les soldes, fournir le support client et securiser la plateforme.'
    ]
  },
  {
    title: '3. Authentification Google',
    items: [
      'Lorsque vous utilisez la connexion Google, nous recuperons uniquement les informations necessaires a l identification du compte, comme le nom, l adresse email et, si disponible, la photo de profil.',
      'La connexion Google est reservee aux comptes revendeurs et reste soumise a une validation administrative interne.'
    ]
  },
  {
    title: '4. Partage des donnees',
    items: [
      'Nous ne vendons pas vos donnees personnelles.',
      'Les donnees peuvent etre partagees uniquement avec nos prestataires techniques strictement necessaires au fonctionnement du service, comme Firebase et Google Authentication.'
    ]
  },
  {
    title: '5. Conservation et securite',
    items: [
      'Nous mettons en place des mesures techniques et organisationnelles raisonnables afin de proteger les donnees contre la perte, l acces non autorise ou la divulgation.',
      'Les donnees sont conservees pendant la duree necessaire a la gestion du compte, au suivi des operations et au respect de nos obligations legales.'
    ]
  },
  {
    title: '6. Vos droits',
    items: [
      'Vous pouvez demander l acces, la rectification ou la suppression de vos donnees personnelles, sous reserve de nos obligations legales et de securite.',
      'Pour toute demande relative a vos donnees, vous pouvez nous contacter a l adresse indiquee ci-dessous.'
    ]
  }
];

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:px-8">
        <div className="mb-6 flex items-center justify-between gap-4">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-100"
          >
            <ArrowLeft className="h-4 w-4" />
            Retour a la connexion
          </Link>

          <Link
            to="/terms-of-service"
            className="text-sm font-semibold text-blue-600 transition hover:text-blue-700"
          >
            Voir les conditions d utilisation
          </Link>
        </div>

        <div className="rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          <div className="mb-8 flex items-start gap-4">
            <div className="rounded-2xl bg-blue-50 p-3 text-blue-600">
              <ShieldCheck className="h-7 w-7" />
            </div>
            <div>
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-blue-600">
                VoucherPro
              </p>
              <h1 className="mt-2 text-3xl font-black text-slate-900">
                Politique de confidentialite
              </h1>
              <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-600">
                Cette politique explique quelles donnees nous collectons, pourquoi nous les traitons
                et comment nous les protégeons lorsque vous utilisez la plateforme VoucherPro.
              </p>
              <p className="mt-3 text-xs font-medium text-slate-400">
                Derniere mise a jour : 08/07/2026
              </p>
            </div>
          </div>

          <div className="space-y-6">
            {sections.map((section) => (
              <section key={section.title} className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
                <h2 className="text-lg font-bold text-slate-900">{section.title}</h2>
                <div className="mt-3 space-y-3">
                  {section.items.map((item) => (
                    <p key={item} className="text-sm leading-6 text-slate-600">
                      {item}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-8 rounded-2xl border border-blue-100 bg-blue-50 p-5">
            <h2 className="text-lg font-bold text-slate-900">Contact</h2>
            <p className="mt-3 text-sm leading-6 text-slate-600">
              Pour toute question concernant cette politique de confidentialite ou le traitement de vos
              donnees, contactez-nous a l adresse suivante :
            </p>
            <a
              href="mailto:sofianetizi87@gmail.com"
              className="mt-3 inline-flex text-sm font-semibold text-blue-600 transition hover:text-blue-700"
            >
              sofianetizi87@gmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
